import { render, staticRenderFns } from "./searchlistdetail.vue?vue&type=template&id=65117e72&scoped=true"
import script from "./searchlistdetail.vue?vue&type=script&lang=js"
export * from "./searchlistdetail.vue?vue&type=script&lang=js"
import style0 from "./searchlistdetail.vue?vue&type=style&index=0&id=65117e72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65117e72",
  null
  
)

export default component.exports